import {
  collection, query, limit, getDocs, doc,
  updateDoc, deleteDoc, serverTimestamp, writeBatch,
} from 'firebase/firestore';
import { db } from '../lib/firebase/app';
import type { Report } from '../types';

const COL = 'reports';

export async function getReports(maxCount = 500): Promise<Report[]> {
  const q = query(collection(db, COL), limit(maxCount));
  const snap = await getDocs(q);
  return snap.docs
    .map(d => ({ id: d.id, ...d.data() } as Report))
    .sort((a, b) => {
      const ta = (a.createdAt as any)?.toDate?.()?.getTime?.() ?? ((a.createdAt as any)?.seconds ?? 0) * 1000;
      const tb = (b.createdAt as any)?.toDate?.()?.getTime?.() ?? ((b.createdAt as any)?.seconds ?? 0) * 1000;
      return tb - ta;
    });
}

export async function updateReportStatus(reportId: string, status: Report['status'], answer?: string): Promise<void> {
  const data: Record<string, unknown> = { status, updatedAt: serverTimestamp() };
  if (answer !== undefined) data.answer = answer;
  await updateDoc(doc(db, COL, reportId), data);
}

export async function deleteReport(reportId: string): Promise<void> {
  await deleteDoc(doc(db, COL, reportId));
}

export async function deleteMultipleReports(ids: string[]): Promise<void> {
  const batch = writeBatch(db);
  ids.forEach(id => batch.delete(doc(db, COL, id)));
  await batch.commit();
}
